export default "/kiban/_next/static/images/bottom_red-a8f4f6354e2e94722d5b470d1a02f4dc.png";